import { FormAccordionSection } from "Components/Shared/FormAccordionSection";
import { ImageUpload } from "Components/Shared/ImageUpload/ImageUpload";
import PaypointImage from "Assets/Images/Images/moone-paypoint.svg";
import { Resources, useResource } from "Translations/Resources";
import { useEffect, useMemo, useState } from "react";

const COMPONENT_RESOURCES = Resources.Components.Merchant.Logo;

type Props = {
  file: File | null;
  onFileChange: (file: File | null) => void;
};

export const PendingLogoPicker = ({ file, onFileChange }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { t } = useResource();

  const previewUrl = useMemo(
    () => (file ? URL.createObjectURL(file) : undefined),
    [file],
  );

  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  return (
    <FormAccordionSection
      legend={t(COMPONENT_RESOURCES.FacilityTitle)}
      isExpanded={isExpanded}
      onToggle={() => setIsExpanded((prev) => !prev)}
      hideIncompleteIcon
    >
      <ImageUpload
        imageUrl={previewUrl}
        isPending={false}
        onUpload={onFileChange}
        onDelete={() => onFileChange(null)}
        placeholder={PaypointImage}
        hint={t(COMPONENT_RESOURCES.Hint)}
      />
    </FormAccordionSection>
  );
};
